import { GetServerSideProps } from "next";
import { getSearchServerSideProps, IExtendedSearchProps } from "src/api/server/extended-search";
import SearchPage from "src/components/pages/search/search-page";
import { LANGUAGE } from "src/consts/locale";
import { IBaseParam } from "src/types/common";

function Page(props: IExtendedSearchProps) {
    return <SearchPage {...props} />;
}

export const getServerSideProps: GetServerSideProps<IExtendedSearchProps, IBaseParam> = async context => {
    if (context.locale !== LANGUAGE.DE) {
        return { notFound: true };
    }

    return getSearchServerSideProps(context);
};

export default Page;
